module.exports = __webpack_public_path__ + "img/sk-pinx-logo.27d97f06.png";